<template>
</template>

<script>

    export default {
        name: 'kubernetes-panel',
        props: {
            readOnly: Boolean,
            value: Object,
            img: String,
        },
        created: function () {
        },
        data: function () {
            return {}
        },
        methods: {
            closePanel() {
                this.$emit('close')
            },
            desDocOpen() {
                //
            }
        }
    }
</script>


<style scoped lang="scss" rel="stylesheet/scss"></style>
